import React from 'react';
import { Box, Typography } from '@mui/material';
import { DOCUMENT } from '../constants/documentTheme';

const DocumentSectionHead = ({ title, meta, actions, sx = {} }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'baseline',
      gap: 1.75,
      pb: 1.4,
      mb: 2.25,
      borderBottom: `1px solid ${DOCUMENT.ruleHard}`,
      flexWrap: 'wrap',
      ...sx,
    }}
  >
    <Typography
      component="h2"
      sx={{
        fontFamily: DOCUMENT.display,
        fontSize: 21,
        fontWeight: 400,
        color: DOCUMENT.ink,
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
    {meta ? (
      <Typography
        sx={{
          ml: actions ? 0 : 'auto',
          fontSize: 10,
          letterSpacing: '0.17em',
          textTransform: 'uppercase',
          color: DOCUMENT.ink3,
        }}
      >
        {meta}
      </Typography>
    ) : null}
    {actions ? <Box sx={{ ml: 'auto' }}>{actions}</Box> : null}
  </Box>
);

export default DocumentSectionHead;
